import { useEffect } from 'react';

const usePageTitle = (title: string) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = `${title} | Valida.do`;
    
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};

export default usePageTitle;